export default __webpack_public_path__ + "static/media/IMG9580.99f0f93c.jpg";